module.exports = __webpack_public_path__ + "media/images/share-arrow-bc4b2f3c35b4b04e2f0b9150ed7f810e.png";